/**
 * 导出通用配置
 */
module.exports = {
  // 标题，此项修改后需要重启项目
  title: '123Plat',
  // 网站标题
  siteTitle: '123Plat - Custom AI Tool Navigation Platform | Large Model Aggregation Platform',
  // 网站加载时显示的内容
  siteLoading: 'Loading 123Plat......',
  // 网站描述
  siteDescription:
    '123Plat (123plat.cloud) is a simple AI tool navigation website that supports custom layouts. It aggregates Chinese large models (such as Wenxin, ERNIE3.0, GLM-3-5XXL, etc.), supports multi-scenario tool classification, and updates the latest AI tools and technologies to help users easily use high-quality AI tools and improve creative efficiency.',
  // 网站关键字
  siteKeywords:
    'AI navigation, 123Plat, custom navigation platform, large model aggregation, GPT4, Chinese models, multilingual models, text generation',
  // 白名单配置，不用令牌就能访问
  whiteList: ['/', '/login', '/about', '/site/:id'],
  // 超级管理员
  superAdmin: 'superAdmin',
  // 所有权限
  allPermission: '*:*:*',
  // 备案号
  recordTitle: ''
}
